<div *ngIf="showSpinner" class="spinner" [ngStyle]="{ color: color ? color : 'black' }"></div>
